export const ParticipantsIcon = () => (
  <svg
    width="44"
    height="45"
    viewBox="0 0 44 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.3333 39.375V35.625C29.3333 33.6359 28.5607 31.7282 27.1854 30.3217C25.8101 28.9152 23.9449 28.125 22 28.125H11C9.05504 28.125 7.18978 28.9152 5.81451 30.3217C4.43924 31.7282 3.66663 33.6359 3.66663 35.625V39.375M29.3333 5.865C30.9058 6.28194 32.2985 7.22112 33.2927 8.53512C34.2869 9.84911 34.8263 11.4635 34.8263 13.125C34.8263 14.7865 34.2869 16.4009 33.2927 17.7149C32.2985 19.0289 30.9058 19.9681 29.3333 20.385M40.3333 39.375V35.625C40.3321 33.9632 39.7913 32.3489 38.7958 31.0356C37.8003 29.7222 36.4065 28.7842 34.8333 28.3688M23.8333 13.125C23.8333 17.2671 20.55 20.625 16.5 20.625C12.4499 20.625 9.16663 17.2671 9.16663 13.125C9.16663 8.98286 12.4499 5.625 16.5 5.625C20.55 5.625 23.8333 8.98286 23.8333 13.125Z"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
);
